/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_6_PInputs */

const en_terms_6_p = /** @type {(inputs: Terms_6_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Bystep web app, CLI and MCP server are our property. The CLI and MCP packages are published on npm under their respective licences for use with the service.`)
};

const id_terms_6_p = /** @type {(inputs: Terms_6_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikasi web Bystep, CLI, dan server MCP adalah milik kami. Paket CLI dan MCP dipublikasikan di npm dengan lisensinya masing-masing untuk dipakai bersama layanan.`)
};

/**
* | output |
* | --- |
* | "The Bystep web app, CLI and MCP server are our property. The CLI and MCP packages are published on npm under their respective licences for use with the service." |
*
* @param {Terms_6_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_6_p = /** @type {((inputs?: Terms_6_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_6_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_6_p(inputs)
	return en_terms_6_p(inputs)
});